import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { UserAttachmentEditionView } from "./UserAttachmentEditionView";
import { UserAttachmentEditionViewStore } from "../../store/UserAttachmentEditionViewStore";
import { useStore } from "../../../../hooks";

export const UserAttachmentEditionViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/userAttachmentEdition/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new UserAttachmentEditionViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <UserAttachmentEditionView userAttachmentEditionViewStore={store} />
      </PageLayout>
    </div>
  );
});
